import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { empty } from 'rxjs/observable/empty';
import { catchError, tap } from 'rxjs/operators';
import { Subscription } from 'rxjs/Subscription';

import { MessageService } from 'primeng/components/common/messageservice';

import { TelefonePipe } from '../../../pipes/mascara-telefone.pipe';
import { FormUtil } from '../../base/util/form.util';
import { DadosBeneficiario } from '../../base/vo/dados-beneficiario';
import { Field } from '../../base/vo/formulario';
import { Gto } from '../../base/vo/gto';
import { EnviarTokenGtoRequest } from '../../base/vo/tokenGto';
import { GtoTokenService } from '../gto-token.service';


@Component({
  providers: [DatePipe],
  selector: 'app-resend-token',
  templateUrl: './resend-token.component.html',
  styleUrls: ['./resend-token.component.scss']
})
export class ResendTokenComponent implements OnInit, OnDestroy {

  @Input() gto: Gto;
  @Input() tokenMensagem: string;

  @Output() readonly stepEmitter: EventEmitter<number> = new EventEmitter();

  private subs: Subscription[] = [];

  public dadosBeneficiario: DadosBeneficiario;
  public loading = false;
  public formGroup: FormGroup;
  public loadingBeneficiario = true;

  public fields: Field[] = [
    {
      controlName: 'telefone',
      label: 'Telefones',
      options: [],
    },
    {
      controlName: 'email',
      label: 'Email',
      options: [],
    }
  ];

  constructor(
    private readonly datePipe: DatePipe,
    private readonly formBuilder: FormBuilder,
    private readonly gtoTokenService: GtoTokenService,
    private readonly messageService: MessageService,
  ) { }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      telefone: ['', [Validators.required]],
      email: ['', [Validators.required]],
    });

    this.getDadosCadastraisBeneficiario();

    this.validationCheck();
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  private setFields() {
    this.fields[0].options = this.dadosBeneficiario.telefones.map(telefone => {
      return {
        id: telefone.numeroTelefone,
        name: new TelefonePipe().transform(`${telefone.numeroDDD}${telefone.numeroTelefone}`),
        value: `${telefone.numeroDDD}${telefone.numeroTelefone}`
      };
    });

    this.fields[1].options = this.dadosBeneficiario.emails.map(email => {
      return {
        id: email.endereco,
        name: email.endereco,
        value: email.endereco
      };
    });
  }

  private getDadosCadastraisBeneficiario() {
    this.loadingBeneficiario = true;

    this.subs.push(this.gtoTokenService.getDadosCadastraisBeneficiario(this.gto.codigoBeneficiario).pipe(
      tap(response => {
        if (response.data) {
          this.dadosBeneficiario = response.data;
          this.setFields();
          this.loadingBeneficiario = false;
        }
      },
        errorResponse => {
          this.messageService.add({
            severity: 'error', summary: 'Erro ao carregar dados do beneficiario.',
            detail: errorResponse.error.errors[0].message
          });
          this.changeStep(0);
        }),
    ).subscribe());
  }

  private validationCheck() {
    this.subs.push(this.formGroup.controls.telefone.valueChanges.pipe(
      tap(_ => {
        this.formGroup.controls.email.clearValidators();
        this.formGroup.controls.email.updateValueAndValidity();
      })
    ).subscribe());

    this.subs.push(this.formGroup.controls.email.valueChanges.pipe(
      tap(_ => {
        this.formGroup.controls.telefone.clearValidators();
        this.formGroup.controls.telefone.updateValueAndValidity();
      })
    ).subscribe());
  }


  private getEnviarTokenGtoObeservable() {
    const channels = [];
    const email = this.formGroup.controls.email.value.value || '';
    let mobile = this.formGroup.controls.telefone.value.value || '';

    if (email) {
      channels.push('email');
    }

    if (mobile) {
      channels.push('whatsapp');
      channels.push('sms');
      mobile = `+55${mobile}`;
    }

    const enviarTokenGtoRequest: EnviarTokenGtoRequest = {
      clientData: {
        docType: 'CPF',
        docValue: this.dadosBeneficiario.numeroCPF,
        email,
        mobile,
        name: this.gto.nomeBeneficiario
      },
      message: {
        channel: channels.join(','),
        email,
        mobile,
        text: this.gtoTokenService.formatarTokenMensagem(this.tokenMensagem, this.gto.nomeBeneficiario, this.gto.numero),
        type: 1
      },
      token: {
        idToken: this.gto.idToken,
      }
    };

    return this.gtoTokenService.enviarTokenGto(enviarTokenGtoRequest).pipe(
      catchError(errorResponse => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Erro ao reenviar token.', detail: errorResponse.error.errors.details });

        return empty();
      }),
    );
  }

  private resendToken() {
    this.loading = true;

    this.subs.push(this.getEnviarTokenGtoObeservable().pipe(
      tap(_ => {
        this.loading = false;
        this.changeStep(0);
        this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Token reenviado com sucesso' });
      },
        _ => {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Erro ao reenviar token.', detail: 'Tente novamente mais tarde.' });
        })
    ).subscribe());
  }

  public submit() {
    FormUtil.checkFormValidations(this.formGroup);
    if (this.formGroup.valid) {
      this.resendToken();
    }
  }

  public changeStep(step: number) {
    this.stepEmitter.emit(step);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/gto-token/resend-token/resend-token.component.ts